// extracted by mini-css-extract-plugin
module.exports = {"RegularButton":"RegularButton_RegularButton__3h82a"};